// extracted by mini-css-extract-plugin
export default {"Loading":"singleLoading_Loading__VGyfj"};